import { deepGet } from "../../../../../utils/utility";
import { DatosCotizacion, GetPricesResponseData, Recibo } from "../../../../../services/TravelServices.dto";

export const getFormatedPayments = (data: GetPricesResponseData) => {
  const recibo: Recibo | undefined = deepGet(data, "body.RESPUESTA.RECIBOS.0");
  const cotizacion: DatosCotizacion | undefined = deepGet(data, "body.RESPUESTA.DATOS_COTIZACION.COTIZACION");
  if (!recibo) return;

  const priceData = {
    price: {
      payType: recibo.PERIODO_COBRO,
      netPremium: recibo.PRIMANETA,
      discount: "",
      taxs: recibo.TOTAL_IMPUESTOS,
      totalPremium: recibo.PRIMATOTAL,
      requestNumber: cotizacion,
    },
    priceResponse: data,
  };

  return priceData;
};
